import { BlocksIconSocialLinkedin } from 'blocks-nextjs/blocks-web-components/components/icon/icons/social-linkedin';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSocialLinkedin = createComponent({
  react: React,
  tagName: 'cat-icon-social-linkedin',
  elementClass: BlocksIconSocialLinkedin
});
